const schools = {
  schools: "Ecoles",
  school: "Établissement",
  schoolName: "Nom de l'établissement",
  schoolAddress: "Adresse de l'établissement",
  schoolDetail: "Détail établissement",
  schoolStatus: "Statut",
  schoolStatusProspect: "Prospect",
  schoolIsPrepaidStudentSubscriptions: "Abonnement pour les étudiants",
  schoolContact: "Contact",
  schoolStatusContract: "Under contract",
  purgeSelection: "Purger les établissements sélectionnés",
  purgeWarning:
    "Toutes les classes, devoirs, et données associées seront définitivement supprimés.",
  clickToDeleteSchool:
    "Cochez cette case pour supprimer également l'établissement de la base de données.",
  clickToDeleteSchools:
    "Cochez cette case pour supprimer également les établissements de la base de données.",
  numberSelected: "Nombre d'établissements sélectionnés :",
  purgeSingleSchool: "Purger cet établissement ?",
  purgeSchool: "Purger cet établissement",
  establishment: "Établissement",
  establishments: "Établissements",
  establishmentsAndClasses: "Établissements et classes",
};

export default schools;
